import React from 'react';
import { observer } from "mobx-react";
import { ShowableCart } from 'ReactApp/Ddd/Aggregates/ShowableCart';
import { PaymentNs } from 'ReactApp/Types/PaymentNs';
import {MarketingEventVariableTypeEnum} from "../../../app/frontend/assets/js/enums/MarketingEventVariableTypeEnum";
import {MarketingEventTypeEnum} from "../../../app/frontend/assets/js/enums/MarketingEventTypeEnum";
import {biMarketingEventRunnerRun} from "../../../app/frontend/assets/js/services/bi/WithBiMarketingEventRunner";
import {CurrencyTypeEnum} from "../../../app/frontend/assets/js/enums/CurrencyTypeEnum";

type PaymentRadioListElementV1Props = {
    showableCart: ShowableCart,
    paymentInfo: PaymentNs.PaymentInfoInterface,
    inputName: string,
}

const PaymentRadioListElementV1 = observer((props: PaymentRadioListElementV1Props) => {

    const addPaymentInfo = React.useRef(false);

     // вызывается при начале добавления платежной информации
    const startedAddPaymentHandler = () => {
        biMarketingEventRunnerRun({
            eventTypeId: MarketingEventTypeEnum.addPaymentInfo,
            dynamicData: {
                [MarketingEventVariableTypeEnum.currency]: CurrencyTypeEnum.RUB,
                [MarketingEventVariableTypeEnum.value]: props.showableCart.totalBaseSum,
                [MarketingEventVariableTypeEnum.revenue]: props.showableCart.totalBaseSum,
                [MarketingEventVariableTypeEnum.paymentType]: props.showableCart.order?.paymentType,
                [MarketingEventVariableTypeEnum.items]: props.showableCart.getCardsForMarketingEventsFormat(),
            }
        });
    }

    const handleAddPaymentInfoOnce = () => {
         if (!addPaymentInfo.current) {
             addPaymentInfo.current = true;
             startedAddPaymentHandler();
         }
     }

    const paymentTypeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.showableCart.order.paymentType = parseInt(e.currentTarget.value) || null;
        handleAddPaymentInfoOnce();
    }

    return (
        <>
            <div className="input-radio-v1">
                <div className="form-group">
                    <label>
                        <input 
                            type="radio" 
                            className="input-radio-v1__input" 
                            name={props.inputName} 
                            value={props.paymentInfo.type}
                            checked={props.showableCart.order.paymentType === props.paymentInfo.type}
                            onChange={paymentTypeHandler}
                        /> 
                        <div className="input-radio-v1__radio-label">
                            <div className="input-radio-v1__radio-label-title">
                                {
                                    typeof props.paymentInfo.title === 'function' 
                                        ? props.paymentInfo.title()
                                        : props.paymentInfo.title
                                }
                            </div>
                            {props.showableCart.order.paymentType === props.paymentInfo.type && (
                                <div className="input-radio-v1__radio-label-info">
                                    {
                                        typeof props.paymentInfo.info === 'function' 
                                            ? props.paymentInfo.info()
                                            : props.paymentInfo.info
                                    }
                                </div>
                            )}
                        </div>

                        {/* 
                            Иконка всплывающего тултипа слева от title-а, 
                            продидывать данные в PaymentNs.PaymentInfoInterface
                            если потребуется в будущем
                            Пока делаем как на текущем сайте (доп. инфа
                            отображается при активации элемента радио-кнопки)
                            <span className="input-radio-v1__radio-tooltip-icon" data-tooltip-data="Оплата вашего заказа банковской картой на сайте через систему электронных платежей Яндекс.Касса. Мы принимаем следующие способы оплаты: банковскими картами VISA, Mastercard, Maestro, Мир, JCB; Apple Pay; Google Pay; Яндекс.Деньги; оплата в кредит; Сбербанк онлайн; WebMoney; Qiwi кошелёк; Альфа-Клик."> 
                                <svg className="icon-v1" width="14" height="14">
                                    <use xlinkHref="/build/sprite.svg#info-icon"></use>
                                </svg>
                            </span> 
                        */}

                    </label>
                </div>
            </div>
        </>
    );

})

export default PaymentRadioListElementV1;